// Set the date we're counting down to
var countDownDate = new Date("Nov 28 2025 00:00:00 UTC+0800 (HKT)").getTime();

// Update the count down every 1 second
var x = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();
    
  // Find the distance between now and the count down date
  var distance = countDownDate - now;
    
  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
  // Output the result in an element with id="demo"
  document.getElementById("timer").innerHTML = (days<10 ? "0" + days : days) + "D:" + (hours<10 ? "0" + hours : hours) + "H:"
  + (minutes<10 ? "0" + minutes : minutes) + "M:" + (seconds<10 ? "0" + seconds : seconds) + "S";
    
  // If the count down is over, write some text 
  if (distance < 0) {
    clearInterval(x);
    document.getElementById("timer").innerHTML = "BLACK FRIDAY SALE LIVE!";
  }
}, 1000);